import React from 'react'
import UploadIcon from '@material-ui/icons/CloudUpload'
import ACL from '@components/ACL'
import {
  Input,
  Dialog,
  DialogTitle,
  Button,
  Typography,
  DialogContent,
  DialogActions,
  Tooltip,
  LinearProgress
} from '@material-ui/core'
import XLSX from 'xlsx'

const EXCEL_COLUMN_MAPPING = {
  'First Name': 'firstName',
  'Last Name': 'lastName',
  position: 'position',
  company: 'company',
  email: 'email'
}

function parseFile(setStatus) {
  return new Promise((resolve, reject) => {
    setStatus({text: 'Reading XLS file'})
    const reader = new FileReader()

    reader.onload = function (e) {
      setStatus({text: 'Processing XLS file'})
      var data = e.target.result
      const workbook = XLSX.read(data, {
        type: 'binary'
      })

      const rows = workbook.SheetNames.map(function (sheetName) {
        return XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName])
      }).flat()

      setStatus({
        text: `Extracted all rows. ${rows.length} total`,
        total: rows.length,
        done: 0
      })

      resolve(rows)
    }

    reader.onerror = function (err) {
      console.error(err)
      setStatus({
        text: `An error occured`,
        error: err,
        total: 0,
        done: 0
      })
      reject(err)
    }

    reader.readAsBinaryString(
      document.querySelector('#icon-button-file').files[0]
    )
  })
}

function validateRow(row) {
  return Object.keys(EXCEL_COLUMN_MAPPING).every(key => Boolean(row[key]))
}

function validateRows(rows) {
  return rows.every(validateRow)
}

function convertRowToItem(row) {
  return Object.keys(EXCEL_COLUMN_MAPPING).reduce(
    (o, key) => ({...o, [EXCEL_COLUMN_MAPPING[key]]: row[key]}),
    {}
  )
}

const wait = (timeInMilliseconds) =>
  new Promise(resolve => setTimeout(resolve, timeInMilliseconds))

async function importXLS(setStatus, addItem, dispatch) {
  const rows = await parseFile(setStatus)

  const isValid = validateRows(rows)

  if (!isValid)
    return setStatus({
      text: `Invalid rows found. Aborting.`,
      error: true,
      finished: true
    })

  for (const [index, row] of rows.entries()) {
    const currentExcelRowItem = index + 1
    await addItem(convertRowToItem(row)).catch((err) => {

      setStatus({
        text: `Error occured while importing item ${currentExcelRowItem} of ${rows.length}`,
        total: rows.length,
        done: currentExcelRowItem
      })

      dispatch({type: 'ROW_FAIL', payload: {rowPosition: currentExcelRowItem, item: row}})

      return wait(1000)
    })

    setStatus({
      text: `Processing rows ${currentExcelRowItem} of ${rows.length}`,
      total: rows.length,
      done: currentExcelRowItem
    })
  }
  setStatus({
    text: `Excel file was successfully imported`,
    finished: true
  })
}

const initialState = {
  text: '',
  total: 0,
  done: 0,
  finished: false,
  error: null,
  showDialog: false,
  failedRows: []
}

function statusReducer(state, {type, payload}) {
  switch (type) {
    case 'SET_STATUS':
      return {
        ...state,
        ...payload
      }
    case 'OPEN_DIALOG':
      return {
        ...state,
        showDialog: true
      }
    case 'ROW_FAIL':
      return {
        ...state,
        failedRows: [...state.failedRows, payload]
      }
    case 'CLOSE_DIALOG':
      return initialState
    default:
      return state
  }
}

const XLSImporter = ({addItem}) => {
  const [state, dispatch] = React.useReducer(statusReducer, initialState)

  const setStatus = s => dispatch({type: 'SET_STATUS', payload: s})
  return (
    <ACL roles={['ImportALList']}>
        <>
          <label htmlFor="icon-button-file" style={{cursor: 'pointer', marginRight: 6}}>
            <Input
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              id="icon-button-file"
              onChange={() => {
                dispatch({type: 'OPEN_DIALOG'})
                importXLS(setStatus, addItem, dispatch)
              }}
              type="file"
              style={{display: 'none'}}
            />
          <div
            style={{
              fontFamily:
                '"Roboto", "Helvetica", "Arial", sans-serif',
              fontWeight: 500,
              height: '25px',
              width: '80px',
              textTransform: 'none',
            }}>
              <UploadIcon />
              <span style={{
                position: 'relative',
                bottom: '7px',
                paddingLeft: '3px'
            }}>Upload</span>
            </div>
          </label>
        </>


      <Dialog open={state.showDialog}>
        <DialogTitle>Importing experts from excel...</DialogTitle>
        <DialogContent style={{minWidth: 400}}>
          {state.failedRows.map(row => (

            <div>
              <Typography variant={'caption'} color={'red'} key={row.rowPosition}>Failed importing excel row: {row.rowPosition} - {(row.item?.['First Name'] || '').toString()}</Typography>
            </div>
          )
          )}
          {state.total && (
            <div>
              <LinearProgress
                variant="determinate"
                value={Math.floor((state.done / state.total) * 100)}
              />
            </div>
          )}
          <Typography variant="caption">{state?.text}</Typography>
          <DialogActions>
            <Button
              color="primary"
              disabled={!state.finished}
              onClick={() => dispatch({type: 'CLOSE_DIALOG'})}>
              Close
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </ACL>
  )
}

export default XLSImporter
